import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapPaginated } from './normalize'

export async function getRawDataCollection({
  farmId,
  year,
  namespace = undefined,
  sort = undefined,
  page = 0,
  size = 10,
  signal = undefined,
}) {
  const response = await apiClient.get(endpoints.v2.rawDataCollection, {
    params: { farmId, year, namespace, sort, page, size },
    signal,
  })
  return unwrapPaginated(response).items
}
